import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { BigFooterBodyCallToActionBlockConfig } from '@front-platform/content-builder';
import { bigFooterBodyCallToActionBlockResolveConfig } from '@front-platform/content-builder';
import { Component, input } from '@angular/core';
export interface BigFooterBodyCallToActionBlockRuntimeConfig {
  '"button-size-y"'?: 'S' | 'M' | 'L';
}

export type BigFooterBodyCallToActionBlockConfigInput = Partial<
  Omit<BigFooterBodyCallToActionBlockConfig, keyof BigFooterBodyCallToActionBlockRuntimeConfig> &
    BigFooterBodyCallToActionBlockRuntimeConfig
>;
export type BigFooterBodyCallToActionBlockResolvedConfig = Omit<
  BigFooterBodyCallToActionBlockConfig,
  keyof BigFooterBodyCallToActionBlockRuntimeConfig
> &
  Partial<BigFooterBodyCallToActionBlockRuntimeConfig>;
export interface BigFooterBodyCallToActionBlockContract extends ConfigComponentContract<
  BigFooterBodyCallToActionBlockConfigInput,
  BigFooterBodyCallToActionBlockResolvedConfig
> {}

@Component({
  selector: 'app-big-footer-body-call-to-action-block',
  templateUrl: './big-footer-body-call-to-action-block.component.html',
  standalone: false,
})
export class BigFooterBodyCallToActionBlockComponent implements BigFooterBodyCallToActionBlockContract {
  readonly config = input<BigFooterBodyCallToActionBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    BigFooterBodyCallToActionBlockConfig,
    BigFooterBodyCallToActionBlockRuntimeConfig
  >(bigFooterBodyCallToActionBlockResolveConfig, () => ({ config: this.config() }));
  get title(): string | undefined {
    return this.resolvedConfig()['title'] as unknown as string | undefined;
  }
  get urlButton(): string | undefined {
    return this.resolvedConfig()['url_button'] as unknown as string | undefined;
  }
  get labelButton(): string | undefined {
    return this.resolvedConfig()['label_button'] as unknown as string | undefined;
  }
  get buttonSizeY(): 'S' | 'M' | 'L' {
    return this.resolvedConfig()['"button-size-y"'] as unknown as 'S' | 'M' | 'L';
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(BigFooterBodyCallToActionBlockComponent, {
  'keyAliases': { 'button_size_y': '"button-size-y"' },
});
